import { useState } from "react";
import { IoClose } from "react-icons/io5";

import { paymentConfirmationServices as confirmation } from "./../../../services/paymentConfirmationServices";

import Modal from "./../../../components/common/Modal";
import TableControls from "./../../../components/common/TableControls";
import TableSize from "./../../../components/common/TableSize";
import TextboxSearch from "./../../../components/common/TextboxSearch";
import PaymentConfirmationFilter from "./PaymentConfirmationFilter";

const PaymentConfirmationHeader = ({ options, onChange }) => {
  const statuses = confirmation.getPaymentConfirmationStatuses();

  const [showFilter, setShowFilter] = useState(false);

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.status = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (status) => {
    const new_options = { ...options };
    new_options.status = status;
    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };
    if (item === 1) new_options["status"] = "";
    onChange(new_options);
  };

  const renderStatus = (status) => {
    const selected = statuses.filter((i) => i.value === status);
    return selected[0].label;
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500 text-sm">Payment Confirmations</p>
          <span className="text-gray-400 text-xs">
            Uploaded Payment Confirmations
          </span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
        </div>
      </div>
      <div className="mt-1 float-right">
        <div className="flex gap-2">
          {options.status !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {renderStatus(options.status)}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        borderTop
      >
        <PaymentConfirmationFilter options={options} onFilter={handleFilter} />
      </Modal>
    </>
  );
};

export default PaymentConfirmationHeader;
